import { Stack, Typography, styled } from "@mui/material";

import { STORE_STATUS_ENUM, type StoreStatus } from "@/constants/enums";

/**
 * The full-width status band the original paints directly under the menu's
 * top bar — green "🕓 Open now" while the kitchen is taking orders, and the
 * tenant's own closed / break copy otherwise.
 *
 * Colours come from the palette, not from the landing page's status-dot hexes:
 * OPEN → success.main, CLOSED → warning.main, BREAK → primary.main, and the
 * disabled background while the shifts are still being evaluated.
 */

const Band = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "storeStatus",
})<{ storeStatus?: StoreStatus }>(({ theme, storeStatus }) => ({
  borderRadius: 0,
  height: 25,
  padding: 0,
  fontSize: 14,
  fontWeight: 500,
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor:
    storeStatus === STORE_STATUS_ENUM.OPEN
      ? theme.palette.success.main
      : storeStatus === STORE_STATUS_ENUM.CLOSED
        ? theme.palette.warning.main
        : storeStatus === STORE_STATUS_ENUM.BREAK
          ? theme.palette.primary.main
          : theme.palette.action.disabledBackground,
  color: "#fff",
}));

interface StoreStatusBannerProps {
  status?: StoreStatus;
  message?: string;
}

export default function StoreStatusBanner({
  status,
  message,
}: StoreStatusBannerProps) {
  return (
    <Band storeStatus={status} role="status">
      <Typography variant="body2" color="inherit">
        {message || "Loading..."}
      </Typography>
    </Band>
  );
}
